import { Controller } from 'stimulus'

/**
 * Opens the shared Balance child-selector bottom sheet from a trigger elsewhere in
 * the page (the "X for {name} ▾" header row). Uses a `bottom-sheet-modal` outlet so
 * the trigger can reference the sheet by id regardless of DOM nesting — this keeps it
 * from colliding with other bottom-sheet-modal instances on the same screen (e.g. the
 * "New message" sheet on the messages screen). See child_selector_trigger.html.
 */
export default class extends Controller {
  declare bottomSheetModalOutlet: import('./bottom-sheet-modal_controller.js').default
  static outlets = ['bottom-sheet-modal']

  open(): void {
    this.bottomSheetModalOutlet.showModal()
  }
}
